import React, { useState } from 'react'
import {
  useResourceContext,
  Button,
  useRecordContext,
  useTranslate,
  useNotify,
  useRedirect,
  useCreate,
  Confirm,
  useDataProvider
} from 'react-admin'
import { Link } from 'react-router-dom'
import FileCopyIcon from '@mui/icons-material/FileCopy'
import { generateRandomString } from 'src/helper/generateRandomString'
import { PAYMENT_CHARGE, CONTENT, SETTING, BILLING, PRICE, LIQUIDATION } from 'src/components/pages/sales/business-rule/helper/const'

export const CloneButton = () => {
  const record = useRecordContext()
  const resourceName = useResourceContext()
  const dataProvider = useDataProvider();
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [create] = useCreate()
  const [isOpen, setIsOpen] = useState(false)
  if (!record) return null

  const transformRule = (data) => {
    let randomString = generateRandomString(8)
    const body = {
      ...data,
      name: data.name + ' Clon ' + randomString,
      is_active: false,
      priority: 0, //because the user must be choice one
    }

    if (data?.air) {
      body.air = {
        source_relation: data.air.source_relation, // represent 'all' option
        // destination: data.air.destination,
        destination: { exclude: null, include: ['all'] },
        airline_code: data.air.airline_code,
        route: data.air.route,
      }
    }
    if (data?.hotel) {
      body.hotel = {
        parameters: {},
        supplier: data.hotel.supplier,
        city: data.hotel.city,
        country: data.hotel.country,
        source_relation: data.hotel.source_relation,
      }
    }

    if (data?.train_segment) {
      if (
        data?.rule_type_id === LIQUIDATION ||
        data?.rule_type_id === PRICE ||
        data?.rule_type_id === BILLING
      ) {
        body.train_segment = {
          supplier: data?.train_segment?.supplier,
          marketing_carrier: data?.train_segment?.marketing_carrier,
        }
      }
      if (data?.rule_type_id === SETTING) {
        body.train_segment = {
          setting: data?.train_segment?.setting,
        }
      }
      if (data?.rule_type_id === CONTENT) {
        body.train_segment = {
          content: data?.train_segment?.content,
        }
      }
    }

    if (data?.car) {
      body.car = {
        renter: data?.car?.renter,
        destination: data?.car?.destination,
      }
    }

    if (data?.payment) {
      // const cards = transformCards(data.payment.payment_method_card)
      let payment = data?.payment?.card?.map((pay) => ({
        id: pay.id,
        name: pay.name || '',
        payment_method: null,
      }))
      body.payment = payment
    }
    if (data?.payment_gateway) {
      body.payment_gateway = data.payment_gateway
    }
    if (data?.rule_type_id === PAYMENT_CHARGE) {
      // 6 is PAYMENT_CHARGE
      let bank = null
      let payment_method = null
      let card = null
      if (data.payment_charge?.payment_type?.include?.includes('CARD')) {
        payment_method = data.payment_charge?.list_payment_method?.find(
          (elem) => elem.id === data.payment_charge?.payment_method
        )
        card = payment_method?.cards.find((elem) => elem.id === data.payment_charge?.card)
      }
      if (
        data.payment_charge?.payment_type?.include?.includes('TRANSFER') ||
        data.payment_charge?.payment_type?.include?.includes('DEPOSIT')
      ) {
        bank = data.payment_charge?.list_bank?.find((elem) => elem.id === data.payment_charge?.bank)
        if (bank) {
          bank = {
            short_name: bank?.code,
            long_name: bank?.name,
            id: bank?.id,
          }
        }
      }

      body.payment_charge = {
        payment_type: data.payment_charge?.payment_type,
        payment_method: payment_method,
        bank: bank,
        card: card,
      }
    }
    if (data?.rule_type_id === CONTENT) {
      body.content = data.content
    }
    // if (data?.rule_type_id === 6) {
    //   body.payment_charge = data?.payment_charge
    // }
    return body
  }

  const defaultTransform = (data) => {
    let randomString = generateRandomString(8)
    const body = {
      ...data,
      short_name: data.short_name + ' Clon ' + randomString,
    }
    
    return body
  }

  const transformInstallment = (data) =>{
    const body = {...data, is_active:false}
    return body
  }

  const transform = (data) => {
    if (resourceName === 'business-rule') {
      return transformRule(data)
    } else if (data.short_name) {
      return defaultTransform(data)
    } else if(resourceName === 'installment') {
      return transformInstallment(data)
    }

    throw new Error(`Unsupported resource: ${resourceName}`);
  }

  const onSuccess = async (data) => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate(`ra.single_entity.${resourceName}`) },
    })
    redirect('edit', resourceName, data.id)
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate(`ra.single_entity.${resourceName}`) },
    })
  }

  const createClone = async () => {
    try {
      const { data: entityToClone } = await dataProvider.getOne(resourceName, { id: record.id });
      if (entityToClone) {
        const data = transform(entityToClone)
        await create(
           resourceName,
          {
            data: data,
          },
          { mutationMode: 'pessimistic', onSuccess: async (e) => await onSuccess(e), onError }
        )
        return
      }
      onError()
    } catch (error) {
      onError(error)
    }
  }

  return (
    <>
      <Button
        component={Link}
        label={''}
        onClick={(e) => {
          e.stopPropagation()
          setIsOpen(true)
        }}
        title={translate('ra.action.clone', { name: translate(`ra.single_entity.${resourceName}`)})}
      >
        <FileCopyIcon />
      </Button>
      <Confirm
        isOpen={isOpen}
        title={translate('ra.action.clone', { name: translate(`ra.single_entity.${resourceName}`)})}
        content={translate('ra.message.sure_to_clone', { entity: translate(`ra.single_entity.${resourceName}`)})}
        onConfirm={async () => {
          setIsOpen(false)
          await createClone()
        }}
        onClose={() => setIsOpen(false)}
      />
    </>
  )
}
